import { useSelector } from 'react-redux';
import { Icon, Surface, Txt } from '@vst/beam';
import { ViasatLogomarkColor } from '@vst/beam-icons/logos/viasat';
import { useTranslation } from 'react-i18next';

import { selectConfig } from '@app/redux/config';

import { Platform } from '@mfe/shared/schema-types';

import { AppleAppStoreButton } from './apple-app-store-button';
import { GooglePlayStoreButton } from './google-play-store-button';

import styles from './styles.module.scss';

type Variant = 'default' | 'blue';

type MobileAppAdProps = {
  variant?: Variant;
};

const MobileAppAd = ({ variant = 'default' }: MobileAppAdProps): JSX.Element | null => {
  const { t } = useTranslation('Network', { keyPrefix: 'advertisement' });
  const { platform } = useSelector(selectConfig);
  if (platform !== Platform.Web) return null;

  const androidAppUrl = t('androidUrl');
  const iosAppUrl = t('iosUrl');

  return (
    <div className={`${styles['container']} ${styles[variant]}`}>
      <Surface p={'8px'} radius="8px" width={40} height={40} className={styles['logo-container']}>
        <Icon icon={ViasatLogomarkColor} height={21} width={21} />
      </Surface>
      <div className={styles['sub-container']}>
        <div className={styles['sub-container']}>
          <div className={styles['text-container']}>
            <Txt variant="heading6">{t('title')}</Txt>
            <Txt variant="smallRegular">{t('body')}</Txt>
          </div>
        </div>
        <div className={styles['buttons']}>
          <div style={{ marginRight: '16px' }}>
            <GooglePlayStoreButton url={androidAppUrl} />
          </div>
          <AppleAppStoreButton url={iosAppUrl} />
        </div>
      </div>
    </div>
  );
};

export default MobileAppAd;
